import React, {useContext} from "react";
import {ChevronRightIcon} from "@heroicons/react/24/outline";
import {showMultiLingualText} from "@/utils/LanguageUtils";
import {SettingsContext} from "@/SettingsContext";

export default function ListItemTemplate(params) {

    const { tourSettings } = useContext(SettingsContext);
    const { children } = params;

    return (
        <div className={`flex flex-1 min-h-[6em] ${params.preview ? 'cursor-pointer bg-white' : 'mx-2 my-2'}`}>

            {tourSettings?.points_display_image &&
                <div className={`flex h-28 w-28 relative overflow-hidden bg-gray-200 ${params.preview ? ' rounded-l-lg' : 'rounded-lg'}`}>

                    { params.image &&
                        <img className={`object-cover h-full w-full`} alt={params.title} src={params.image} />
                    }
                { params.icon && <div className={`absolute m-2`}><img className={`h-8`} alt={params.title} src={params.icon}/></div> }
                </div>
            }
            
            <div className={`flex flex-1 flex-col px-3 overflow-hidden justify-between`}>
                <div>
                    <div className={`${params.preview ? 'pt-3' : ''}` }>
                        <p className="text-sm font-bold line-clamp-2">
                        { showMultiLingualText(params.title, params.name, true) }
                        </p>
                    </div>
                    
                    {params.description &&
                        <p className="text-sm line-clamp-4 pt-1">
                            {showMultiLingualText(params.description)}
                        </p>
                    }
                </div>
                
                {children && (
                    <div className="py-2 relative mt-auto">
                        {children}
                    </div>
                )}
            </div>

            { !tourSettings?.points_display_image &&
                <div className={`flex items-center justify-center mx-2 overflow-hidden`}>
                    { params.icon && <img className={`w-10`} alt={params.title} src={params.icon}/> }
                </div>
            }

            <div className={`flex items-center p-2 ${params.activeRoute ? 'hidden' : ''}`} >
                <ChevronRightIcon className={`w-5 h-5 text-gray-400`}/>
            </div>

        </div>
    );
}